var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Defaults, Utils, Watch, PropertyConverters } from '@pacem/pacem-core';
import { PacemContenteditableButtonCommandElement, CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE } from './types';
import { ContenteditableUtils } from './utils';
//namespace Pacem.Components.Scaffolding {
let PacemContenteditableLinkCommandElement = class PacemContenteditableLinkCommandElement extends PacemContenteditableButtonCommandElement {
    isRelevant(range) {
        return !Utils.isNull(ContenteditableUtils.findSurroundingNode(range, HTMLAnchorElement));
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (Utils.isNullOrEmpty(this.altText)) {
            this.altText = 'insert link';
        }
        if (Utils.isNullOrEmpty(this.icon)) {
            this.icon = 'insert_link';
        }
        if (Utils.isNullOrEmpty(this.keyboardShortcut)) {
            this.keyboardShortcut = 'Ctrl+H';
        }
    }
    exec(arg, target = this.target) {
        return new Promise((resolve, reject) => {
            var selection = this.range;
            var anchorNode = ContenteditableUtils.findSurroundingNode(selection, HTMLAnchorElement);
            //console.log('selection: ' + selection);
            var current = "http://";
            var regex = /<a.*href=\"([^\"]*)/;
            if (anchorNode && regex.test(anchorNode.outerHTML)) {
                current = regex.exec(anchorNode.outerHTML)[1];
            }
            //console.log('link: ' + current);
            if (arg === 'current') {
                return current == 'http://' ? '' : current;
            }
            var link = arg || (arg === void 0 && window.prompt('link (empty to unlink):', current));
            if (!link) {
                document.execCommand('unlink');
            }
            else {
                document.execCommand('createLink', false, link);
                anchorNode = ContenteditableUtils.findSurroundingNode(selection, HTMLAnchorElement);
                if (anchorNode) {
                    anchorNode.setAttribute('target', target || '_blank');
                }
            }
            resolve();
        });
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemContenteditableLinkCommandElement.prototype, "target", void 0);
PacemContenteditableLinkCommandElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable-linkcommand', shadow: Defaults.USE_SHADOW_ROOT,
        template: CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE
    })
], PacemContenteditableLinkCommandElement);
export { PacemContenteditableLinkCommandElement };
